import React, { Component } from 'react'
import ProfilePicture from 'components/profile/profile-picture'
//import TimeAgo from 'react-timeago'
import TimeAgo from 'timeago-react'
import moment from 'moment'

import { connect } from 'react-redux'
import { withRouter, Link } from 'react-router-dom'

import { 
	getCurrentAccount,
	getNotificationList
} from 'state/selectors'

import LoadMore from 'components/load-more/load-more'

import {
	seeNotifications,
	setNotificationOpenStatus,
	markAllNotificationsRead,
	fetchMoreNotifications,
	createOrReturnChat,
} from 'state/actions'

import AlertBanner from 'components/alerts/alert-banner'

import { getNotificationUrl, formatByTimeZone } from 'utils'

class Notifications extends Component {
	state = {
		maxVisibleItems: 10,
		isFetchingMore: false,
		hasMore: true,
	}

	componentDidMount(){
		const {
			handleTouchMove
		} = this.props

		this.element = document.getElementById("notifications-list")

		this.element.addEventListener('touchmove', e => {
			handleTouchMove(e, 'move')
		}, {
			passive: false
		})

		this.element.addEventListener('touchstart', e => {
			handleTouchMove(e, 'start')
		}, {
			passive: false
		})
	}

	componentWillUnmount(){
		const {
			handleTouchMove,
			seeNotifications
		} = this.props

		this.element.removeEventListener('touchmove', e => {
			handleTouchMove(e, 'move')
		})

		this.element.removeEventListener('touchstart', e => {
			handleTouchMove(e, 'start')
		})

		seeNotifications()
	}

	handleNotificationClick = notification => {
		const { setNotificationOpenStatus, closeCallback } = this.props
		setNotificationOpenStatus(notification.object)
		closeCallback()
	}

	// Chats aren't route-addressable, so a chat @mention notification opens the
	// chat through the dock (redux) rather than navigating to a URL.
	handleChatNotificationClick = notification => {
		const { createOrReturnChat, userData } = this.props
		const message = notification.notifyable

		if (message && message.chat_id) {
			createOrReturnChat({ id: message.chat_id }, userData)
		}

		this.handleNotificationClick(notification)
	}

	loadMore = _ => {
		const { maxVisibleItems } = this.state
		const { notificationsList: { notifications } } = this.props

		if (maxVisibleItems < notifications.length) {
			this.setState({ maxVisibleItems: maxVisibleItems + 10 })
			return
		}

		this.setState({ isFetchingMore: true })
		this.props.fetchMoreNotifications(notifications.length, count => {
			this.setState({
				isFetchingMore: false,
				maxVisibleItems: maxVisibleItems + count,
				hasMore: count === 20,
			})
		})
	}

	render() {
		const { maxVisibleItems, isFetchingMore, hasMore } = this.state

		const {
			notificationsList,
			userData,
			object,
			markAllNotificationsRead,
			handleScroll,
			allEntities,
			currentAccount
		} = this.props

		const {
			shouldShowAccounts,
			notifications
		} = notificationsList

		const slicedNotifications = notifications.slice(0, maxVisibleItems)

		return (
			<div>
				<h3 className="no-border">
					{ object.name }
					<div className="header-tab-controls">
						{
							slicedNotifications.length ?
							<button className={'active header-button'} onClick={_ => {markAllNotificationsRead()}}>
								<span>
									Mark all as read
								</span>
							</button>
							: null
						}
					</div>
				</h3>
				<div 
					className="header-tab headertab-list-container" 
					ref="listContainer" 
					onScroll={e => { 
						handleScroll(this.refs.listContainer.scrollTop, e) 
					}}
					id="notifications-list"
				>
					{
						slicedNotifications.length ?
						<ul className="headertab-list">
							{
								slicedNotifications.map(notification => {
									let instigator = notification.instigator ? notification.instigator : null

									// We can just fake it, if we don't have the instigator in state.
									if(!instigator && notification.instigator_name){
										instigator = {
											image_tiny_thumb_url: notification.instigator_image_url,
											image_thumb_url: notification.instigator_image_url,
											image_url: notification.instigator_image_url
										}
									}

									const isChatMention = notification.type === 'message'

										const url = (notification.canOpen && !isChatMention)
											? getNotificationUrl(allEntities, notification.object, currentAccount)
											: null

										const content = <>
											{
												!notification.object.has_opened &&
												<i className="alert-dot"></i>
											}
											<ProfilePicture
												user={instigator}
												isFromHassl={!instigator}
												isTiny={true}
											/>
											<div className="list-item-content">
												<div className="title" dangerouslySetInnerHTML={{ __html: notification.text }} />
												<span className="meta">
													<TimeAgo datetime={formatByTimeZone(notification.object.created_at, 'YYYY-MM-DD HH:mm:ss')} />
													{ notification.type !== 'project' && notification.notifyable?.project_id && allEntities.projects[notification.notifyable.project_id] ?
														' • ' + allEntities.projects[notification.notifyable.project_id].name
														: null
													}
													{ (shouldShowAccounts && notification.account) ?
														' • '+notification.account.name
														: null
													}
												</span>
											</div>
										</>

										return (
										<li
											className={!notification.object.has_opened ? 'unseen list-item' : 'seen list-item'}
											key={notification.object.id}
										>
										{ url ? <Link
											to={url}
											onClick={_ => this.handleNotificationClick(notification)}
											className="notification-link"
										>
											{ content }
										</Link> : isChatMention ? <a
											onClick={_ => this.handleChatNotificationClick(notification)}
											className="notification-link"
										>
											{ content }
										</a> : <>
											{ content }
										</> }
										</li>
									);
								})
							}
							<LoadMore
								isLoading={isFetchingMore}
								canLoadMore={notifications.length > slicedNotifications.length || hasMore}
								onClick={this.loadMore}
								type="notifications"
							/>
						</ul>
						:
						<AlertBanner 
							title={"Nothing to report, "+userData.first_name+"!"} 
							body="Get in there and make things happen." 
						/>
					}
				</div>
			</div>
		)
	}
}

function mapStateToProps(state, ownProps){
  return {
	allEntities: state.account.entities,
	notificationsList: getNotificationList(state, ownProps),
	currentAccount: getCurrentAccount(state),
  };
}

export default withRouter(connect(mapStateToProps, {
	seeNotifications,
	setNotificationOpenStatus,
	markAllNotificationsRead,
	getNotificationUrl,
	fetchMoreNotifications,
	createOrReturnChat,
})(Notifications))
